
import { computed } from "vue";
export default {
  name: "EwgTab",
  props: {
    tabList: {
      type: Array,
      default: () => []
    },
    value: {
      type: [Number, String],
      required: true
    },
    useLabel: {
      type: Boolean,
      default: false
    }
  },
  setup(props: any, context: any) {
    const valueName = computed(() => {
      return props.useLabel ? "label" : "value";
    });
    const handleChoose = (row: any) => {
      if (row.disabled) return;
      if (row[valueName.value] === props.value) return;
      context.emit("update:value", row[valueName.value]);
    };
    return {
      handleChoose,
      valueName
    };
  }
};
